import React from "react";
import PropTypes from "prop-types";
import PaypalUpgradeForm from "components/payments/PaypalUpgradeForm";
import StripeUpgradeForm from "components/payments/StripeUpgradeForm";

export default function UpgradeForm(props) {
  const {
    defaultErrorMessage,
    FormButtons,
    lastPaidWithStripe,
    paypalEnvironment,
    PaypalButton,
    planCode,
    planId,
    StripePaymentElement,
    upgradePrice
  } = props;

  if (lastPaidWithStripe) {
    return (
      <StripeUpgradeForm
        defaultErrorMessage={defaultErrorMessage}
        FormButtons={FormButtons}
        planCode={planCode}
        planId={planId}
        StripePaymentElement={StripePaymentElement}
        upgradePrice={upgradePrice}
      />
    );
  }
  return (
    <PaypalUpgradeForm
      defaultErrorMessage={defaultErrorMessage}
      paypalEnvironment={paypalEnvironment}
      PaypalButton={PaypalButton}
      planCode={planCode}
      planId={planId}
      upgradePrice={upgradePrice}
    />
  );
}

UpgradeForm.propTypes = {
  FormButtons: PropTypes.element.isRequired,
  PaypalButton: PropTypes.element,
  StripePaymentElement: PropTypes.element,
  lastPaidWithStripe: PropTypes.bool.isRequired,
  paypalEnvironment: PropTypes.string.isRequired,
  planCode: PropTypes.string.isRequired,
  planId: PropTypes.string.isRequired,
  upgradePrice: PropTypes.shape({
    errorMessage: PropTypes.string,
    price: PropTypes.string,
    prorationDate: PropTypes.string
  }).isRequired
};
